import React from 'react'
import { ExpertByCategoryComponent } from '#src/generated/graphql'
import TeaserChatWidget from '#src/components/EngagementChannels/TeaserChatWidget'

interface Props {
  categoryId: string
}

const TeaserChatWidgetWithExpert: React.SFC<Props> = ({ categoryId }) => (
  <ExpertByCategoryComponent variables={{ categoryId }}>
    {({ data }) => {
      if (
        !data ||
        !data.category ||
        !data.category.recommendExpertForConsumer.expert ||
        !data.category.ancestorWithPath
      ) {
        return null
      }

      return (
        <TeaserChatWidget
          expert={data.category.recommendExpertForConsumer.expert}
          pathCategory={data.category.ancestorWithPath}
          getAppRoot={() => document.querySelector('#deal')}
        />
      )
    }}
  </ExpertByCategoryComponent>
)

export default TeaserChatWidgetWithExpert
